import { createStore } from "easy-peasy";
import model from "../model/index";

const store = createStore(model);

export default store;
